import React from 'react'
import { useHistory } from 'react-router-dom'
import { useAnalytics } from 'reactfire'

import { Wrap, Title, Paragraph, LoadingWrap, Button } from './styled'

import { PieNoShadowIcon, LoadingIcon, CloseIcon } from 'src/components/Icons'
import { getQuizMatches } from 'src/api/quizMatches/quizMatches'
import { QUIZZES_COMPLETED } from 'src/constants/routes'
import { analyticsEvents } from 'src/constants/analytics/events'
import { QuizMatches } from 'src/api/quizMatches/types'
import { breakpoints } from 'src/styles/media'
import { useMedia } from 'src/hooks/useMedia'

interface CompleteQuizLoaderProps {
  bgStart: string
  bgEnd: string
  quizId: number
  onMatchesCalculated: (quizMatches: QuizMatches) => void
}

const CompleteQuizLoader: React.FC<CompleteQuizLoaderProps> = ({
  bgStart,
  bgEnd,
  onMatchesCalculated,
  quizId,
}) => {
  const { push } = useHistory()
  const { logEvent } = useAnalytics()
  const isDesktop = useMedia(breakpoints.desktop)

  const handleClose = () => {
    logEvent(analyticsEvents.quizCalculationClosed)
    push(QUIZZES_COMPLETED)
  }

  React.useEffect(() => {
    const interval = setInterval(async () => {
      const quizMatches = await getQuizMatches(quizId)

      if (quizMatches.data.length) {
        logEvent(analyticsEvents.quizCalculationFinished)
        onMatchesCalculated && onMatchesCalculated(quizMatches)
      }
    }, 3000)

    return () => clearInterval(interval)
  }, [logEvent, onMatchesCalculated, push, quizId])

  return (
    <Wrap bgStart={bgStart} bgEnd={bgEnd}>
      <Button onClick={handleClose}>
        <CloseIcon />
      </Button>
      <PieNoShadowIcon
        width={isDesktop ? undefined : 131}
        height={isDesktop ? undefined : 100}
      />
      <Title>You did it!</Title>
      <Paragraph>You&apos;ve finished the quiz.</Paragraph>
      <Paragraph>We&apos;re calculating your results.</Paragraph>
      <LoadingWrap>
        <LoadingIcon />
      </LoadingWrap>
    </Wrap>
  )
}

export default CompleteQuizLoader
